export  const accordionItems = [
    {
        title: "Яка основна перевага використання нашого європейського пального?",
        content: "Наше пальне відзначається високою якістю, надійністю та чистотою, що забезпечує оптимальну продуктивність вашого автомобіля.",
    },
    {
        title: "Які види пального доступні на вашій автозаправній станції?",
        content: "Бензин, Газ, ДП",
    },
    {
        title: "Які переваги використання газового палива?",
        content: "Головна перевага газу—порівняно низька ціна. За роботи на газі ресурс двигуна підвищується у 1,5-2 рази. При цьому збільшується період між замінами оливи і свічок.",
    },
    {
        title: "Чи маєте ви сертифікати якості для свого палива?",
        content: "Так, звісно. З ними можна ознайомитися в розділі вище - Якість, що гарантується.",
    },
    {
        title: "Чи маєте ви бонусну програму для постійних клієнтів?",
        content: "Так. Вся інформація в розділі  - Бонусна програма.",
    },
];